import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { useFreeCancellationDaysAheadNotification } from '../../../../common/custom-hooks/freeCancellationDaysAheadNotification';
import type { Bound } from '../../models';

interface freeCancellationDaysAheadNotificationProps {
  bounds: Bound[];
}

const FreeCancellationDaysAheadNotification = ({
  bounds,
}: freeCancellationDaysAheadNotificationProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const freeCancellationDaysAheadNotification = useFreeCancellationDaysAheadNotification(
    bounds?.[0]?.segments?.[0]?.departuredAt,
  );

  const notificationText = freeCancellationDaysAheadNotification
    ? t('BookingFlow.FreeCancellation.DaysAhead.Text')
    : t('BookingFlow.FreeCancellation.Text');

  const notificationTestId = freeCancellationDaysAheadNotification
    ? 'freeCancellationInformationDaysAhead-search-result'
    : 'freeCancellationInformation-search-result';

  return freeCancellationDaysAheadNotification || p('BookingFlow.FreeCancellation.Enable') ? (
    <Notification dataTestId={notificationTestId} variant={variants.INFORMATION}>
      <DangerousHtmlContent content={notificationText} />
    </Notification>
  ) : null;
};

export default FreeCancellationDaysAheadNotification;
